import React from 'react';

import {observer} from 'mobx-react';
import {EntityLogo} from "../../../../core/components/logos/entity-logo";
import classNames from "classnames";
import styles from "../../styles/language-menu.module.scss";
import {LANGUAGE_MENU} from "../../language-menu-module.consts";
import {Link} from "../../../../core/components/link/link";

export const LanguageMenuModuleHeaderItem = observer(({controller, language, index}) => {
  const {state} = controller;
  const {isMenuOpen, menuModel} = state;
  const {logoSize, shouldArrowOpenMenu, numOfHeaderItemsDisplay, headerName} = menuModel;

  const onItemClick = (language) => controller.action(LANGUAGE_MENU.ACTION_TYPES.onItemClick, {language})
  const shouldHideItem: Boolean = !isMenuOpen && index >= numOfHeaderItemsDisplay;
  const name: String = shouldArrowOpenMenu ? headerName : language.name;

  const itemProps = {
    model: language.linkModel,
    className: classNames(styles.header_item, {[styles.hide_item]: shouldHideItem}),
    onClick: !shouldArrowOpenMenu ? () => onItemClick(language) : null,
  }

  const logoProps = {
    className: classNames(styles.header_logo),
    entity: language,
    width: logoSize,
    height: logoSize
  };

  return (
    <Link {...itemProps}>
      <EntityLogo {...logoProps}/>
      {name}
    </Link>
  )
});
